import React from 'react';
import { Card } from '../../../components/ui/Card';
import { Button } from '../../../components/ui/Button';
import { TabNavigation } from '../../../components/operations/TabNavigation';
import { OperationsSwitcher } from '../../../components/operations/OperationsSwitcher';
import { MapPin, Clock, Users, Package, ChevronDown, Search, Plus } from 'lucide-react';
const LOCATION_TABS = [{
  label: 'Overview',
  path: ''
}, {
  label: 'Capacity',
  path: 'capacity'
}, {
  label: 'Performance',
  path: 'performance'
}, {
  label: 'Costs',
  path: 'costs'
}, {
  label: 'Settings',
  path: 'settings'
}];
const LOCATIONS = [{
  name: 'Vračar',
  address: 'Njegoševa 42, Belgrade',
  hours: '10:00 - 23:00',
  staff: 3,
  orders: 127,
  status: 'good',
  capacity: 'Good'
}, {
  name: 'Banovo Brdo',
  address: 'Požeška 128, Belgrade',
  hours: '10:00 - 23:00',
  staff: 2,
  orders: 84,
  status: 'warning',
  capacity: 'High Load'
}, {
  name: 'Novi Beograd',
  address: 'Bulevar Zorana Đinđića 4a',
  hours: '09:00 - 00:00',
  staff: 4,
  orders: 156,
  status: 'good',
  capacity: 'Good'
}];
export function Overview() {
  return <div className="space-y-6 animate-in fade-in duration-500" data-id="element-1907">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4" data-id="element-1908">
        <h1 className="text-2xl font-bold text-text-primary" data-id="element-1909">Locations</h1>
        <div className="flex items-center gap-3" data-id="element-1910">
          <div className="relative" data-id="element-1911">
            <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-text-secondary" data-id="element-1912" />
            <input type="text" placeholder="Search..." className="bg-background-elevated border border-white/10 rounded-lg pl-9 pr-4 py-2 text-sm focus:outline-none focus:border-accent-primary w-48" data-id="element-1913" />
          </div>
          <Button icon={<Plus size={16} data-id="element-1915" />} data-id="element-1914">Add</Button>
        </div>
      </div>

      <OperationsSwitcher data-id="element-1916" />

      <TabNavigation tabs={LOCATION_TABS} basePath="/operations/locations" data-id="element-1917" />

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-1918">
        {LOCATIONS.map(loc => <Card key={loc.name} className="flex flex-col" data-id="element-1919">
            <div className="flex justify-between items-start mb-4" data-id="element-1920">
              <div className="flex items-center gap-2" data-id="element-1921">
                <MapPin className="text-accent-primary" size={20} data-id="element-1922" />
                <h3 className="font-bold text-lg" data-id="element-1923">{loc.name}</h3>
              </div>
              <span className={`px-2 py-1 rounded text-xs font-bold ${loc.status === 'good' ? 'bg-accent-success/20 text-accent-success' : 'bg-accent-warning/20 text-accent-warning'}`} data-id="element-1924">
                {loc.capacity}
              </span>
            </div>

            <div className="space-y-3 flex-1" data-id="element-1925">
              <div className="text-sm text-text-secondary" data-id="element-1926">{loc.address}</div>
              <div className="flex items-center gap-2 text-sm text-text-muted" data-id="element-1927">
                <Clock size={14} data-id="element-1928" /> {loc.hours}
              </div>

              <div className="grid grid-cols-2 gap-4 mt-4 p-3 bg-background-elevated rounded-lg" data-id="element-1929">
                <div className="flex items-center gap-2" data-id="element-1930">
                  <Users size={16} className="text-text-secondary" data-id="element-1931" />
                  <span className="font-bold" data-id="element-1932">{loc.staff}</span>
                  <span className="text-xs text-text-secondary" data-id="element-1933">staff</span>
                </div>
                <div className="flex items-center gap-2" data-id="element-1934">
                  <Package size={16} className="text-text-secondary" data-id="element-1935" />
                  <span className="font-bold" data-id="element-1936">{loc.orders}</span>
                  <span className="text-xs text-text-secondary" data-id="element-1937">orders</span>
                </div>
              </div>
            </div>

            <Button variant="secondary" className="w-full mt-6" data-id="element-1938">
              View Details
            </Button>
          </Card>)}
      </div>
    </div>;
}